import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";

export default function HireHelpPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>Hire help - Equibre</title>
                <meta name="description" content="We're excited to collaborate with you on your next big project. Here’s how you can get started." />
            </Helmet>
            <section className="page-header-section steps-section">
                <div className="inner">
                    <div className="header">
                    <h1>Hire help</h1>
                    <p>We're excited to collaborate with you on your next big project. Here’s how you can get started :</p>
                    </div>
                    <div className="content">
                        <div className="step-line">
                            <div className="step-index">
                                <h2>#1</h2>
                            </div>
                            <div className="step-content">
                                <h3 className="step-hdr">Fill the form</h3>
                                <p className="step-text">Begin by filling out the form below with some basic information about your project and contact details. This helps us understand your initial requirements and how best to assist you.</p>
                            </div>
                        </div>
                        <div className="step-line">
                            <div className="step-index">
                                <h2>#2</h2>
                            </div>
                            <div className="step-content">
                                <h3 className="step-hdr">We Reach Out</h3>
                                <p className="step-text">Once we receive your form, our team will promptly reach out to you via WhatsApp or a phone call. We'll discuss the project details and answer any initial questions you may have. This is your opportunity to explain your project in whichever way you prefer – be it through a detailed conversation, document sharing, or even a brainstorming session.</p>
                            </div>
                        </div>
                        <div className="step-line">
                            <div className="step-index">
                                <h2>#3</h2>
                            </div>
                            <div className="step-content">
                                <h3 className="step-hdr">Project Discussion</h3>
                                <p className="step-text">During our communication, we'll dive deeper into your project requirements, goals, and vision. We'll discuss timelines, deliverables, and any other specifics needed to ensure we are on the same page.</p>
                            </div>
                        </div>
                        <div className="step-line">
                            <div className="step-index">
                                <h2>#4</h2>
                            </div>
                            <div className="step-content">
                                <h3 className="step-hdr">Contract Agreement</h3>
                                <p className="step-text">After understanding your project in detail, we'll draft a contract that outlines the scope of work, timelines, payment terms, and other important aspects. This contract ensures transparency and sets clear expectations for both parties.</p>
                            </div>
                        </div>
                        <div className="step-line">
                            <div className="step-index">
                                <h2>#5</h2>
                            </div>
                            <div className="step-content">
                                <h3 className="step-hdr">Project Kick-off</h3>
                                <p className="step-text">Once the contract is signed, we will begin working on your project. Our team of experts will keep you updated throughout the development process, ensuring your vision is brought to life with precision and quality.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="about-page-section">
                <div className="inner">
                    <div className="content">
                        <div className="page-content">
                            <h1 className="page-content-hdr">
                                Our mission is to make your life easy with satisfaction so you can
                                focus on your bussiness. We strive to achieve this by focusing on
                                three core principles.
                            </h1>
                        </div>
                        <div className="page-content">
                            <a href="#">Learn more</a>
                        </div>
                        <div className="page-image">
                            <img src="https://f.start.me/us.gov" />
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <section className="about-page-section">
                <div className="inner">
                    <div className="content">
                        <div className="page-content">
                            <h1 className="page-content-hdr">Our services</h1>
                        </div>
                        <div className="page-image">
                            <img src="https://f.start.me/us.gov" />
                        </div>
                    </div>
                </div>
            </section> */}

            <ContactListSection />
        </>
    );
}